var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _path2, _path3, _path4, _path5, _linearGradient6, _path6, _path7, _linearGradient7, _clipPath, _clipPath2, _clipPath3, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _path8, _path9, _path10, _path11, _path12, _ellipse, _path13, _ellipse2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g, _path71, _path72, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g2, _linearGradient24, _linearGradient25, _path81, _path82, _path83, _path84, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 2035",
    width: 3000,
    height: 2035,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1846.0714285714284 962.1428571428571) rotate(0.0 222.32142857142867 200.3571428571429) scale(1.073643122061064 1.0734463060626946)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 414.144,
    height: 373.297,
    viewBox: "0 0 414.144 373.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#bf78a9",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db9dc6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 232.72,
    x2: 652.21,
    xlinkHref: "#a",
    y1: 203.869,
    y2: 485.525
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 230.668,
    x2: 81.027,
    y1: 212.848,
    y2: 82.085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#a49acb",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a599ca"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 288.158,
    x2: 361.513,
    y1: 170.033,
    y2: 82.894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#bf78a9",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e499c2"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 193.866,
    x2: 446.769,
    xlinkHref: "#a",
    y1: 280.291,
    y2: 494.015
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.826 365.701H22.318c-8.284 0-15-6.716-15-15V22.596c0-8.284 6.716-15 15-15h369.508c8.284 0 15 6.716 15 15v328.105c0 8.284-6.716 15-15 15z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.674 229.27H57.949c-8.284 0-15-6.716-15-15V57.006c0-8.284 6.716-15 15-15h168.725c8.284 0 15 6.716 15 15V214.27c0 8.284-6.716 15-15 15z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M389.144 10c8.284 0 15 6.716 15 15v323.296c0 8.285-6.716 15-15 15H25c-8.284 0-15-6.715-15-15V25c0-8.284 6.716-15 15-15zm0-10H25C11.215 0 0 11.215 0 25v323.296c0 13.785 11.215 25 25 25h364.144c13.785 0 25-11.215 25-25V25c0-13.785-11.215-25-25-25z",
    fill: "#bf78a9",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.064 229.27H275.16c-8.284 0-15-6.716-15-15V57.006c0-8.284 6.716-15 15-15h83.904c8.284 0 15 6.716 15 15V214.27c0 8.284-6.715 15-15 15z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.064 325.685H57.949c-8.284 0-15-6.716-15-15v-36.042c0-8.284 6.716-15 15-15h301.116c8.284 0 15 6.716 15 15v36.042c-.001 8.284-6.716 15-15.001 15z",
    fill: "url(#e)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1120.7142857142858 608.5714285714286) rotate(0.0 156.42857142857133 156.42857142857144) scale(1.0715166412894988 1.071520311181241)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 291.976,
    height: 291.975,
    viewBox: "0 0 291.976 291.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 43.178,
    x2: 280.02,
    y1: 86.835,
    y2: 223.105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#a49acb",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7670b0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.976 8c8.284 0 15 6.716 15 15v245.976c0 8.284-6.716 15-15 15H23c-8.284 0-15-6.716-15-15V23c0-8.284 6.716-15 15-15zm0-8H23C10.318 0 0 10.318 0 23v245.976c0 12.682 10.318 23 23 23h245.975c12.682 0 23-10.318 23-23V23c.001-12.682-10.317-23-22.999-23z",
    fill: "#7770b1",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.975 283.975H23c-8.284 0-15-6.716-15-15V23c0-8.284 6.716-15 15-15h245.975c8.284 0 15 6.716 15 15v245.975c0 8.285-6.715 15-15 15z",
    fill: "url(#f)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.64285714285714 373.92857142857144) rotate(0.0 1091.2499999999998 747.3214285714284) scale(1.0725827694799703 1.0731309648516656)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2034.808,
    height: 1392.787,
    viewBox: "0 0 2034.808 1392.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 428.986,
    x2: 1364.427,
    y1: -280.365,
    y2: 274.374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7670b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#1e1e1e"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1352.511 213.895-20.574 76.486c-6.539 24.31 9.656 48.864 34.577 52.424 20.703 2.957 40.423-9.787 46.23-29.878l21.902-75.764c5.469-18.917-2.957-39.092-20.256-48.501l-1.328-.722c-23.827-12.959-53.505-.238-60.551 25.955z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1418.917 153.907c12.196-.944 13.109-12.046 13.109-12.046s-5.768-12.252-14.967-12.632c-12.644-.522-21.684 11.14-24.958 16.469.001 0 14.621 9.153 26.816 8.209z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1483.062 147.495c-8.877 6.11-21.586-5.65-21.586-5.65s4.191-11.14 10.913-13.661c11.542-4.328 15.111 7.708 15.111 7.708s1.459 7.544-4.438 11.603z"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#f6dcc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3caad"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 1248.391,
    x2: 1314.579,
    xlinkHref: "#g",
    y1: 88.882,
    y2: 73.081
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 1179.512,
    x2: 1367.747,
    y1: 176.941,
    y2: 132.003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7670b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e1e1e"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 596.522,
    x2: 1299.152,
    y1: 736.657,
    y2: 736.657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#a49acb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770b1"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: -84.971,
    x2: 303.068,
    xlinkHref: "#g",
    y1: 1201.616,
    y2: 1107.9
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 577.124,
    x2: -5.382,
    y1: 769.414,
    y2: 1103.618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#a49acb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770b1"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 1137.874,
    x2: 1410.456,
    y1: 871.152,
    y2: 513.117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#a49acb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770b1"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 1478.358,
    x2: 1176.105,
    y1: 592.46,
    y2: 224.062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#eab2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#e499c2"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 828.435,
    x2: 1140.748,
    xlinkHref: "#g",
    y1: 1001.466,
    y2: 1001.466
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.825 36.593c-31.201-19.924-97.991-.031-104.675 55.576-3.444 28.648-21.45 62.027-47.435 71.003-46.286 15.988-88.543-3.886-120.282 22.334-43.798 36.181-36.423 84.409-36.423 84.409s37.271 33.371 68.163 35.701c-9.311-7.906-8.897-24.228-4.634-31.978 6.899-12.54 39.88 29.104 44.196 33.507 31.809 2.692 128.025 24.662 158.25 40.568 25.487 13.412 108.406-54.532 90.564-112.979-13.863-45.412-31.596-158.332-31.596-158.332s14.231-20.423-16.128-39.809z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m1352.511 213.895-20.574 76.486c-6.539 24.31 9.656 48.864 34.577 52.424 20.703 2.957 40.423-9.787 46.23-29.878l21.902-75.764c5.469-18.917-2.957-39.092-20.256-48.501l-1.328-.722c-23.827-12.959-53.505-.238-60.551 25.955z",
    fill: "#e18265"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#i)",
    d: "M1436.373 276.567s-56.916-7.082-71.881-34.793-8.985-48.175-8.985-48.175l95.777 49.896z",
    fill: "#a3302c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.951 67.048s27.585 23.258 30.925 52.102c3.34 28.843 11.227 44.37 6.387 72.942s-15.69 67.783-30.925 70.589-85.277-12.048-95.464-27.563c-10.187-15.516-39.328-100.506-39.328-100.506l19.16-70.926 72.425-16.238z",
    fill: "#e18265"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1418.917 153.907c12.196-.944 13.109-12.046 13.109-12.046s-5.768-12.252-14.967-12.632c-12.644-.522-21.684 11.14-24.958 16.469.001 0 14.621 9.153 26.816 8.209z",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    clipPath: "url(#j)",
    cx: 1418.98,
    cy: 137.586,
    fill: "#1e1e1e",
    rx: 9.697,
    ry: 14.133,
    transform: "matrix(.9745 -.2245 .2245 .9745 5.3292 322.0456)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1483.062 147.495c-8.877 6.11-21.586-5.65-21.586-5.65s4.191-11.14 10.913-13.661c11.542-4.328 15.111 7.708 15.111 7.708s1.459 7.544-4.438 11.603z",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    clipPath: "url(#k)",
    cx: 1478.184,
    cy: 135.034,
    fill: "#1e1e1e",
    rx: 7.411,
    ry: 12.333,
    transform: "matrix(.9745 -.2245 .2245 .9745 7.413 335.2706)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.708 51.766s-8.575-14.55-37.647 3.811c-35.765 22.588-22.965 45.227-22.965 45.227z",
    fill: "url(#l)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.1 147.698a2 2 0 0 1-1.701-3.05c1.142-1.853 11.622-18.081 27.742-17.418 10.291.425 16.438 13.233 16.694 13.779a2 2 0 0 1-3.618 1.705c-.053-.112-5.376-11.163-13.241-11.488-11.236-.471-20.484 9.537-24.173 15.521a1.994 1.994 0 0 1-1.703.951zm69.035 31.673a2 2 0 0 1-.943-3.765c1.784-.952 7.388-5.575 11.666-9.25-4.434-3.301-14.16-10.956-15.901-15.801-2.237-6.227-4.497-19.093 5.501-35.299 8.495-13.768 19.02-12.333 23.397-9.65a1.999 1.999 0 0 1-2.08 3.416c-.416-.245-9.466-5.36-17.913 8.334-9.118 14.78-7.135 26.297-5.141 31.846 1.293 3.599 10.809 11.348 16.504 15.388a1.998 1.998 0 0 1 .158 3.137c-1.135.992-11.183 9.739-14.31 11.407-.298.161-.62.237-.938.237zm-73.228-57.899a1.999 1.999 0 0 1-1.466-3.359c.519-.559 12.885-13.688 28.958-13.688 11.792 0 18.075 6.833 18.336 7.124a2 2 0 0 1-2.968 2.681c-.226-.247-5.44-5.805-15.368-5.805-14.302 0-25.911 12.286-26.027 12.41a1.996 1.996 0 0 1-1.465.637z",
    fill: "#1e1e1e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.476 143.844a2 2 0 0 1-1.872-2.704c.184-.49 4.597-12.022 12.083-14.829 10.503-3.939 17.432 3.995 19.628 8.741a2 2 0 0 1-3.63 1.68c-.196-.417-4.961-10.287-14.594-6.675-4.801 1.8-8.662 9.629-9.744 12.493a2 2 0 0 1-1.871 1.294z",
    fill: "#1e1e1e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.802 164.842s18.058-24.528 16.403-51.297c0 0 35.015-27.853 27.902-53.173 0 0 51.405-1.808 78.791 31.462 0 0 .458-14.884-18.347-30.524-29.337-24.4-61.279-28.461-90.069-21.943-33.63 7.614-72.728 34.396-81.554 66.518-11.93 43.419 8.624 89.876 25.428 102.934 27.366 21.266 38.073 20.741 38.073 20.741l13.137-35.387z",
    fill: "url(#m)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1431.319 205.688s11.609-11.017 28.111-8.724c12.382 1.72 13.058 8.492 13.058 8.492s-4.395 6.386-14.989 7.179c-13.05.977-26.18-6.947-26.18-6.947z",
    fill: "#942224"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.65 209.022a82.16 82.16 0 0 1-7.805-.381c-20.664-1.968-26.689-8.178-26.936-8.442a2.001 2.001 0 0 1 2.921-2.733c.034.033 5.544 5.396 24.394 7.192 19.118 1.82 28.858-3.91 28.955-3.969a2.002 2.002 0 0 1 2.745.669c.573.94.281 2.166-.657 2.743-.374.231-8.206 4.921-23.617 4.921z",
    fill: "#1e1e1e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.333 119.142a3.498 3.498 0 0 1-3.054-1.786l-21.529-38.309a3.5 3.5 0 1 1 6.103-3.429l21.529 38.309a3.5 3.5 0 0 1-3.049 5.215z",
    fill: "#eab2d2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1361.248 166.724s-21.399-33.276-36.348-12.513c-14.949 20.762-3.257 38.791 7.945 49.06 8.038 7.368 29.138 14.122 31.978 1.39s-3.575-37.937-3.575-37.937z",
    fill: "#e18265"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.02 187.184a1.995 1.995 0 0 1-1.522-.702c-9.707-11.373-26.605-21.49-26.774-21.591a2 2 0 0 1 2.045-3.438c.715.425 17.629 10.549 27.772 22.433a2 2 0 0 1-1.521 3.298z",
    fill: "#1e1e1e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.772 192.553a2 2 0 0 1-1.385-3.443l10.523-10.093a2 2 0 0 1 2.769 2.887l-10.523 10.093a1.995 1.995 0 0 1-1.384.556zm46.749-48.354c-1.384 0-2.887-.113-4.398-.425a2 2 0 1 1 .808-3.918c4.395.906 8.92-.278 8.966-.29 1.066-.284 2.163.347 2.449 1.413s-.343 2.161-1.407 2.449c-.159.043-2.903.771-6.418.771z",
    fill: "#1e1e1e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.113 104.305c-.228 0-.459-.022-.691-.069l-43.087-8.635a3.5 3.5 0 0 1 1.376-6.864l43.087 8.635a3.5 3.5 0 0 1-.685 6.933z",
    fill: "#eab2d2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M636.375 380.702s22.853-19.372 51.623-16.525 175.336 53.838 262.457 100.736c35.033 18.858 124.964 65.819 134.933 104.336 10.585 40.895-23.442 106.519-73.671 117.494-94.816 20.717-279.687-60.587-358.307-117.494-24.399-17.661-84.379-53.719-64.013-118.806 20.366-65.088 46.978-69.741 46.978-69.741z",
    fill: "#e499c2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M548.868 420.222s-22.888-9.199-47.331-23.164c-27.812-15.889-34.984-38.85-34.984-38.85l55.513-61.909s43.433 3.647 54.132 25.961c14.17 29.551 38.299 48.15 38.613 62.273.316 14.124-65.943 35.689-65.943 35.689z",
    fill: "#e18265"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M496.048 340.585s-58.868-26.61-77.65-38.732-44.009-38.472-40.487-51.138c3.521-12.666 12.698-8.939 28.301 2.169s76.16 49.907 100.239 56.784c24.079 6.878 13.364 29.883-10.403 30.917z",
    fill: "#e18265"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M495.985 355.651s-57.055-12.392-76.034-19.416-46.622-24.971-46.255-36.284 9.172-9.737 25.16-3.025c15.988 6.713 77.121 29.12 99.603 30.8 22.481 1.681 18.045 22.97-2.474 27.925z",
    fill: "#e18265"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M508.211 313.486c-18.235-5.208-59.145-32.538-83.853-48.47 4.831 6.843 10.565 12.994 15.469 18.011 38.864 39.75 82.43 34.47 68.384 30.459zm-33.318 16.488c-32.056-17.396-48.535-22.177-70.174-30.68 3.988 2.886 7.963 5.452 11.673 7.518 19.529 10.878 64.938 26.655 58.501 23.162z",
    fill: "#a3302c"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M587.145 361.728s-3.031-25.806-7.428-42.78c-3.479-13.433-23.542-37.319-32.447-52.695-20.666-35.683-31.603-55.899-41.657-38.778-8.75 14.903 4.619 39.684 8.428 51.192 3.808 11.508 17.353 39.863 15.697 44.465-1.657 4.604 57.407 38.596 57.407 38.596z",
    fill: "#e18265"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M513.163 328.705s-50.129-33.933-65.447-48.18c-15.319-14.247-34.021-42.867-28.371-54.268s13.543-6.507 26.076 6.306 61.975 58.482 83.225 68.587c21.249 10.105 6.946 30.161-15.483 27.555zm-13.543 51.067s-47.683-9.905-65.783-12.77c-18.1-2.866-45.95-13.362-47.809-22.689-1.859-9.326 6.213-9.376 21.614-6.31s73.659 12.117 93.817 10.071 15.308 24.513-1.839 31.698z",
    fill: "#e18265"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M546.005 376.537c-27.623-3.316-23.567-67.434-19.24-51.703 8.741 31.773 19.24 51.703 19.24 51.703z",
    fill: "#a3302c"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.123 266.254c-24.596-14.16-80.657-10.788-118.25 18.041S904.897 500.584 891.855 562.841s93.326 174.445 164.626 96.584c71.301-77.861 277.376-338.631 182.642-393.171z",
    fill: "#e499c2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m637.672 377.868-33.156-22.647c-3.224-2.202-7.595-.027-7.813 3.872-.48 8.6-2.736 21.81-11.066 33.712-9.083 12.976-24.54 21.123-34.041 25.176-3.535 1.508-4.128 6.26-1.064 8.581 10.143 7.685 28.303 21.297 36.315 26.385a4.993 4.993 0 0 0 4.856.29c6.366-3.075 23.461-12.819 34.57-33.103 10.216-18.652 12.86-31.872 13.544-37.544a4.99 4.99 0 0 0-2.145-4.722z",
    fill: "#eab2d2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M574.768 698.013c65.092 51.615 223.124 153.298 277.399 182.942 98.799 53.963 200.371 74.556 273.615 52.373 73.243-22.184 134.501-172.732 61.415-228.668-73.085-55.936-363.08-134.159-432.221-149.767-68.757-15.521-167.198-46.624-218.089 4.267-50.89 50.889 11.326 117.795 37.881 138.853z",
    fill: "url(#n)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M288.258 906.374s-12.056 27.865-9.741 61.418 2.501 44.987 18.799 68.671 94.743 103.87 130.829 96.507c36.087-7.363 57.394-3.771 68.397-35.136s-1.398-165.587-1.398-165.587L392.787 831.376l-70.041 19.977z",
    fill: "#1e1e1e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M514.031 832.333c-39.088-36.017-101.321-27.434-129.198 17.82-49.267 79.977-118.044 190.793-141.372 224.331-37.812 54.362 96.125 144.113 96.125 144.113l187.182-276.79c23.413-34.619 17.998-81.154-12.737-109.474z",
    fill: "#f3caad"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M412.742 1107.524s-41.188 73.826-50.469 104.016c-9.281 30.191-24.703 72.488-47.191 108.386-22.487 35.898-72.804 67.057-72.804 67.057L13.547 939.992s27.491-33.801 66.005-42.502c21.655-4.892 68.909 6.086 103.327 73.573 22.632 44.378 61.878 103.006 81.467 84.997 12.465-11.461 100.977-38.892 100.977-38.892z",
    fill: "url(#o)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M278.223 1363.34a3 3 0 0 1-1.973-5.26c.492-.44 12.326-11.356 8.453-36.745-8.646-56.682-38.031-119.699-55.588-157.351l-.989-2.122c-18.368-39.407-47.945-118.562-63-164.957-9.041-27.859-25.527-52.102-46.422-68.262-19.029-14.718-39.897-21.379-57.252-18.276a3 3 0 0 1-1.056-5.906c19.022-3.402 41.612 3.683 61.979 19.436 21.839 16.891 39.049 42.162 48.458 71.157 15.002 46.229 44.455 125.063 62.731 164.274l.989 2.121c17.693 37.943 47.305 101.449 56.082 158.982 4.4 28.843-9.832 41.639-10.439 42.17a2.995 2.995 0 0 1-1.973.739z",
    fill: "#e3b194"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1.346 961.658c3.422-14.507 21.763-35.476 32.471-37.123 36.75-5.654 94.219 27.715 114.125 89.059 15.865 48.889 45.137 126.581 62.866 164.615 17.729 38.035 47.95 102.112 56.824 160.288 4.202 27.546-9.419 40.73-32.78 52.935-13.999 7.313-48.988-14.848-81.076-69.293-41.023-69.606-82.348-170.292-102.598-204.652S-7.684 999.943 1.346 961.658z",
    fill: "#e3b194"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M514.031 832.333c-39.088-36.017-101.321-27.434-129.199 17.82a23953.61 23953.61 0 0 1-55.406 89.534c15.399-5.192 40.703-8.403 67.287 10.64 33.418 23.939 52.77 69.436 54.112 103.778l75.942-112.298c23.414-34.619 17.999-81.154-12.736-109.474z",
    fill: "#e18265"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M689.405 780.425c-37.104 65.926-150.341 235.521-163.108 254.878 0 0-24.158-145.301-97.761-181.128-73.604-35.826-59.225-42.185-59.225-42.185s125.887-194.229 143.618-221.623c27.526-42.529 50.38-62.894 112.68-48.516 56.538 13.05 138.662 105.552 63.796 238.574z",
    fill: "url(#p)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M686.94 786.802a2.5 2.5 0 0 1-2.154-3.765c12.191-20.773 27.749-60.505 27.905-60.904a2.5 2.5 0 1 1 4.658 1.818c-.157.402-15.857 40.499-28.25 61.616a2.5 2.5 0 0 1-2.159 1.235z",
    fill: "#7670b0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M702.398 756.474a2.5 2.5 0 0 1-.37-4.972l26.117-3.942a2.5 2.5 0 0 1 .746 4.944l-26.117 3.942a2.524 2.524 0 0 1-.376.028z",
    fill: "#7670b0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M541.908 1023.112c2.761-6.978 4.993-14.142 3.675-21.53-4.093-22.937-14.724-74.475-32.221-105.415-23.015-40.7-68.994-104.032-105.72-107.007-28.388-2.299-69.332 33.195-76.5 44.901-10.976 17.925-42.885 72.313-42.885 72.313s33.7-50.447 67.418-46.755c33.718 3.691 109.399 70.208 123.134 107.699 20.737 56.606 19.759 126.763 9.909 145.443 0 0 29.427-29.598 53.19-89.649z",
    fill: "#8e84be"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1456.19 784.611s-5.153 18.798-17.442 18.768c-12.392-.03-38.59-26.774-38.59-26.774l16.902-71.946z",
    fill: "#1e1e1e"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.045 723.041c-8.431 57.222-21.525 137.969-104.839 215.97s-186.45 68.849-263.176 21.054-162.043-212.83 72.157-422.793c35.951-32.23 319.553 24.953 295.858 185.769z",
    fill: "url(#q)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.218 391.293c25.723-25.723 7.275-56.483 6.813-74.445-2.214-85.985 46.474-62.866 119.763-15.457 31.403 19.362 126.921 3.228 126.921 3.228s82.053-31.618 111.108-33.306c84.819-4.925 29.255 91.486 25.925 209.94-2.371 84.352 24.6 147.637 17.602 215.982-3.695 36.087-52.202 86.744-117.113 75.951L1375.779 638.8l-94.538-76.673c-104.961-28.763-176.725 6.52-179.692 1.204-40.519-72.589 46.946-146.315 72.669-172.038z",
    fill: "url(#r)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m1438.241 299.966-2.327-25.017c-.302-3.251-3.59-5.354-6.661-4.245-13.776 4.972-49.371 15.318-88.806 6.839-8.562-1.841-18.914-8.361-25.105-12.694-2.746-1.922-6.563-.651-7.612 2.533l-11.128 33.77a4.99 4.99 0 0 0 1.842 5.634c7.898 5.624 30.959 20.205 61.845 23.55 33.033 3.577 66.992-19.329 75.94-25.882a4.987 4.987 0 0 0 2.012-4.488z",
    fill: "#eab2d2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.56 661.925a2.5 2.5 0 0 1-1.788-4.247c36.758-37.627 62.285-89.821 62.539-90.344a2.5 2.5 0 1 1 4.499 2.181c-.257.53-26.123 53.435-63.461 91.656a2.492 2.492 0 0 1-1.789.754zm-25.999-16a2.501 2.501 0 0 1-1.768-4.268c33.306-33.306 56.407-79.466 56.637-79.928a2.5 2.5 0 1 1 4.479 2.223c-.233.47-23.701 47.362-57.58 81.241a2.494 2.494 0 0 1-1.768.732z",
    fill: "#7670b0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.322 547.688a2.5 2.5 0 0 1-2.499-2.469c-.02-1.588-.072-3.259-.127-5.015-.601-19.304-1.509-48.476 33.515-92.27 15.409-19.267 28.232-31.996 38.536-42.224 14.987-14.876 24.033-23.856 28.045-39.634 3.878-15.254-6.052-48.168-6.152-48.498a2.5 2.5 0 0 1 4.783-1.458c.428 1.404 10.437 34.583 6.215 51.188-4.353 17.12-14.304 26.999-29.368 41.951-10.213 10.138-22.924 22.755-38.153 41.799-33.874 42.356-33 70.42-32.422 88.991a283.9 283.9 0 0 1 .129 5.109 2.5 2.5 0 0 1-2.469 2.531l-.033-.001z",
    fill: "#ca73ab"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.539 773.505s-5.478-68.846-109.728-172.279c-77.806-77.195-212.482-101.558-254.663-39.28l1.509 18.751s49.336-33.036 112.985-14.953c106.349 30.215 228.426 171.229 227.653 233.466z",
    fill: "#e499c2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1831.815 419.003c-52.95-32.606-91.694-65.503-141.719-96.309s-88.094-65.506-170.794-48.126c-52 10.928-19.944 298.354 79.711 334.466 99.655 36.113 285.986 64.478 310.764-12.994 24.778-77.471-36.782-151.679-77.962-177.037z",
    fill: "#eab2d2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.599 495.719a2.5 2.5 0 0 1-2.483-2.242c-6.969-67.141-.358-117.319 6.415-147.589 7.369-32.936 16.298-49.731 16.675-50.43a2.5 2.5 0 0 1 4.403 2.37c-.358.667-35.693 68.209-22.519 195.134a2.5 2.5 0 0 1-2.491 2.757zm15.867 102.741a2.5 2.5 0 0 1-2.421-1.883c-.06-.235-6.033-23.613-9.881-32.768a2.499 2.499 0 1 1 4.609-1.937c3.991 9.496 9.868 32.496 10.117 33.471a2.5 2.5 0 0 1-2.424 3.117z",
    fill: "#ca73ab"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1931.91 254.456s34.409 54.251 59.346 86.004 41.447 108.981-4.76 198.349S1859.83 643.22 1813.694 643.22c-78.194 0-58.099-206.024-33.957-250.078 26.921-49.126 66.328-83.019 66.328-138.051-.001-30.518 85.845-.635 85.845-.635z",
    fill: "#eab2d2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.312 444.791a2.5 2.5 0 0 1-2.493-2.73c2.594-28.076 15.14-55.394 15.672-56.543a2.5 2.5 0 0 1 4.536 2.102c-.127.274-12.718 27.706-15.23 54.901a2.499 2.499 0 0 1-2.485 2.27z",
    fill: "#ca73ab"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1905.701 110.146s33.085-53.59 46.922-70.143c13.836-16.553 41.515-37.277 52.414-31.933s6.121 13.761-6.311 27.357-56.787 67.01-66.7 89.531c-9.914 22.521-29.045 8.59-26.325-14.812zm-42.241 120.718s-15.78-25.421-22.074-39.804c-6.293-14.383.193-51.932-4.936-71.85s-14.92-39.429-19.579-45.273 3.454-15.192 15.312-11.239c7.449 2.483 26.57 18.68 34.45 37.463 5.941 14.162 23.604 35.472 27.394 38.884 3.793 3.411-30.567 91.819-30.567 91.819z",
    fill: "#e18265"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1934.424 215.947s20.797-35.126 28.518-46.53 23.302-38.068 27.392-45.216 13.58-17.899 25.399-27.403c9.492-7.633 25.173-18.355 16.596-25.007-7.788-6.041-18.096-3.954-39.054 11.134-23.392 16.841-26.755 31.425-26.755 31.425l-72.19-17.575s-17.31 21.852-24.647 44.525-21.04 66.525-13.727 77.997 78.468-3.35 78.468-3.35z",
    fill: "#e18265"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2009.502 21.371c-13.36.379-29.34 17.224-41.063 30.503-21.964 24.879-34.959 59.265-30.86 56.091 8.897-6.89 48.716-58.942 61.148-72.538 5.011-5.481 8.777-10.12 10.775-14.056z",
    fill: "#a3302c"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.48 121.121s13.75-60.827 20.325-78.607c6.576-17.779 24.129-43.337 35.837-42.494s10.396 9.164 4.035 24.107c-6.362 14.943-27.317 72.219-28.242 93.569-.926 21.35-26.093 23.194-31.955 3.425zm51.488-1.374s27.468-48.892 39.266-64.113 36.055-34.614 46.323-30.203 6.338 12.077-4.33 24.613-48.469 61.64-56.356 82.057c-7.888 20.417-26.153 8.614-24.903-12.354z",
    fill: "#e18265"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1932.968 119.747s27.468-48.892 39.266-64.113 36.055-34.614 46.323-30.203 6.338 12.077-4.33 24.613-48.469 61.64-56.356 82.057c-7.888 20.417-26.153 8.614-24.903-12.354z",
    fill: "#e18265"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1960.182 107.578c-4.354 6.436-1.796 10.764 1.161 7.116 12.894-15.906 22.965-23.341 25.49-29.108-7.912 4.382-19.75 11.791-26.651 21.992zm-76.057 92.475c-1.597 36.49 24.371-71.545 12.049-66.349-16.243 6.85-11.41 51.775-12.049 66.349z",
    fill: "#a3302c"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m1844.673 216.789.768 44.515a4.984 4.984 0 0 0 2.541 4.268c5.582 3.123 19.914 10.181 36.601 10.95 23.632 1.089 43.057-8.445 49.788-12.239a4.989 4.989 0 0 0 2.54-4.347l.057-40.796c.004-3.156-2.878-5.522-5.974-4.911-8.79 1.734-25.88 4.636-41.792 4.636-16.792 0-30.172-3.933-37.762-6.837-3.303-1.264-6.828 1.226-6.767 4.761z",
    fill: "#e499c2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M736.202 485.136c31.77 76.758 120.394 242.466 153.399 294.766 60.08 95.203 176.361 192.599 251.147 208.84s165.984-145.507 129.331-229.928c-36.652-84.421-199.631-257.194-252.452-304.46-52.526-47.004-177.497-133.14-246.248-111.856-62.904 19.474-48.138 111.323-35.177 142.638z",
    fill: "#a49acb"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M823.598 847.908s7.903 22.373 64.083 26.322c35.924 2.525 94.269 3.504 127.407-5.015s68.095-16.806 50.917-48.442-92.994-83.801-92.994-83.801l-123.402 2.829-42.812 50.152z",
    fill: "#1e1e1e"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M959.521 1175.856c-3.148 29.463-85.466 128.52-85.466 128.52s13.031 49.469 38.865 75.399c0 0 23.588 9.808 60.134 2.327 36.546-7.48 73.875-45.516 91.671-70.804 17.796-25.287 49.768-77.365 61.078-93.436s41.407-74.143 37.907-97.629c-4.317-28.969-12.377-40.746-34.319-72.099-18.783-26.838-158.613 22.379-169.87 127.722z",
    fill: "#e3b194"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M884.255 658.02c-46.461 14.701-69.048 67.211-47.762 111.048 38.654 79.608 92.019 190.672 99.192 211.696 11.412 33.449 11.851 53.485.594 158.829-3.148 29.463-45.541 86.983-55.194 113.887-14.43 40.217-8.656 56.491 8.594 90.032 0 0 23.588 9.808 60.134 2.327 36.546-7.48 73.875-45.516 91.671-70.804 17.796-25.287 49.768-77.365 61.078-93.436s41.407-74.143 37.907-97.629c-4.317-28.969-12.377-40.746-34.319-72.098-18.784-26.84-24.456-34.479-40.118-79.929-12.239-35.515-54.551-149.681-82.814-225.63-14.849-39.897-58.375-61.136-98.963-48.293z",
    fill: "url(#s)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.321 888.037c-18.443-50.71-46.504-126.365-67.105-181.724-14.847-39.898-58.374-61.136-98.962-48.294-46.461 14.701-69.048 67.211-47.762 111.048 20.09 41.375 44.151 91.242 63.638 132.554 1.886-11.726 8.607-25.434 27.429-34.989 34.715-17.623 91.315-7.955 122.762 21.405z",
    fill: "#e18265"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.015 1152.441h-.042a3 3 0 0 1-2.959-3.041c.011-.789.783-79.225-24.258-112.285-24.391-32.202-35.472-56.434-47.423-84.766-11.735-27.819-37.632-87.813-37.893-88.416a3 3 0 0 1 5.508-2.378c.26.603 26.168 60.62 37.912 88.462 11.786 27.94 22.706 51.827 46.677 83.475 11.093 14.645 18.75 38.657 22.757 71.371 2.961 24.172 2.72 44.417 2.718 44.619a2.998 2.998 0 0 1-2.997 2.959z",
    fill: "#e3b194"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M803.412 340.297c-43.047-5.372-67.347 21.958-78.727 35.431-19.862 23.516-20.28 67.758-12.016 116.712 8.73 51.719 56.28 181.724 87.038 235.612s230.881 11.219 230.881 11.219-129.971-386.843-227.176-398.974z",
    fill: "#a49acb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7670b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1293.35 863.635c-28.094.001-77.326-28.391-119.855-113.516-60.851-121.798-127.683-225.026-162.25-264.047-21.761-24.565-44.657-47.377-64.47-64.234-22.289-18.964-31.319-22.419-33.092-22.174-1.869 2.62 3.27 18.45 5.216 24.443 3.034 9.346 3.755 11.566 1.348 12.902-2.105 1.168-3.833-.885-4.401-1.56l-.526-.625c-28.838-34.334-41.052-38.465-45.762-37.87-1.17.148-2.881.666-4.22 3.454-5.047 10.511 9.439 31.806 24.776 54.351 9.151 13.452 18.614 27.363 26.077 41.613 36.794 70.258 77.709 185.064 90.726 226.65a2.501 2.501 0 0 1-4.772 1.494c-12.974-41.452-53.745-155.864-90.383-225.824-7.329-13.995-16.71-27.785-25.782-41.12-16.872-24.801-31.442-46.22-25.149-59.327 2.209-4.6 5.625-5.938 8.101-6.251 9.425-1.195 24.64 10.185 45.266 33.828l-.055-.171c-5.354-16.492-8.648-28.346-2.236-30.676 5.072-1.838 17.719 5.768 37.593 22.618 20.106 17.046 43.363 40.188 65.488 65.164 27.762 31.339 60.682 82.898 83.41 120.632 27.497 45.651 56.499 98.318 79.569 144.496 25.375 50.789 51.576 77.586 69.088 91.123 19.692 15.223 39.66 22.257 53.411 18.818 15.062-3.767 36.751-16.483 43.79-28.707 2.026-3.518 2.654-6.685 1.867-9.413-3.542-12.281-3.734-18.367-.687-21.706 3.304-3.621 9.296-2.81 16.786-1.374 1.454.279 2.818.606 4.136.923 9.48 2.277 15.741 3.78 29.942-23.536a2.501 2.501 0 0 1 4.437 2.306c-15.232 29.298-23.431 29.002-35.546 26.092-1.263-.303-2.569-.617-3.91-.874-5.066-.971-10.601-1.865-12.151-.166-2.348 2.573.772 13.395 1.797 16.95 1.177 4.083.391 8.555-2.338 13.294-7.779 13.508-30.536 26.967-46.91 31.062-2.506.627-5.295.958-8.329.958z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.02 748.285a2.486 2.486 0 0 1-1.583-.566c-.075-.062-7.654-6.236-18.793-12.169-10.164-5.414-25.465-11.741-40.67-11.127a2.506 2.506 0 0 1-2.599-2.397 2.5 2.5 0 0 1 2.397-2.599c16.358-.657 32.583 6.032 43.317 11.761 11.551 6.165 19.198 12.403 19.518 12.665a2.5 2.5 0 0 1-1.587 4.432zm-281.73-10.256c-1.095 0-2.1-.726-2.407-1.832-30.172-108.75-112.129-268.539-112.953-270.14a2.5 2.5 0 0 1 4.446-2.289c.827 1.606 83.018 161.853 113.325 271.092a2.5 2.5 0 0 1-2.411 3.169z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.995 502.056a2.5 2.5 0 0 1-2.401-3.202c5.618-19.205 5.839-37.372 5.84-37.553.012-1.381 1.142-2.474 2.522-2.478a2.5 2.5 0 0 1 2.478 2.522c-.007.769-.23 19.049-6.041 38.914a2.501 2.501 0 0 1-2.398 1.797zM799.708 730.552a2.5 2.5 0 0 1-2.266-1.441c-45.692-97.651-72.443-179.192-72.707-180.005a2.5 2.5 0 1 1 4.754-1.55c.264.81 26.927 82.078 72.483 179.436a2.5 2.5 0 0 1-2.264 3.56z"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M823.598 847.908s-28.982-84.643-33.32-97.876 7.503-39.132 24.541-48.116c8.022-4.23 64.256-29.626 133.102-3.596 62.485 23.625 85.866 38.02 96.238 50.809 1.735 2.139 3.021 4.602 3.839 7.232l21.502 72.695s-25.726-34.481-66.564-46.148c-40.837-11.668-131.513-18.917-160.824 10.394-21.315 21.315-25.609 33.865-18.514 54.606z",
    fill: "#8e84be"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.082 761.313a2.5 2.5 0 0 1-2.17-1.254c-.64-1.114-64.883-112.241-136.401-186.603a2.5 2.5 0 0 1 3.604-3.466c71.95 74.81 136.488 186.457 137.131 187.576a2.501 2.501 0 0 1-2.164 3.747z",
    fill: "#7670b0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2067.8571428571427 200.35714285714286) rotate(0.0 393.2142857142858 317.6785714285714) scale(1.0715979247790817 1.0727781371795593)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 733.884,
    height: 592.254,
    viewBox: "0 0 733.884 592.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 190.201,
    x2: 687.401,
    y1: 121.3,
    y2: 613.114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#a49acb",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7670b0"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#a49acb",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a599ca"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 64.981,
    x2: 387.35,
    xlinkHref: "#t",
    y1: 152.631,
    y2: 274.5
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 484.46,
    x2: 635.579,
    xlinkHref: "#t",
    y1: 138.674,
    y2: 195.803
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 484.46,
    x2: 635.579,
    xlinkHref: "#t",
    y1: 180.59,
    y2: 237.719
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 484.46,
    x2: 635.579,
    xlinkHref: "#t",
    y1: 222.506,
    y2: 279.636
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 98.701,
    x2: 277.826,
    xlinkHref: "#t",
    y1: 352.819,
    y2: 512.332
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M703.123 580.843H30.761c-11.046 0-20-8.954-20-20V31.411c0-11.046 8.954-20 20-20h672.362c11.046 0 20 8.954 20 20v529.432c0 11.046-8.954 20-20 20z",
    fill: "url(#u)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M699.884 14c11.046 0 20 8.954 20 20v524.253c0 11.046-8.954 20-20 20H34c-11.046 0-20-8.954-20-20V34c0-11.046 8.954-20 20-20zm0-14H34C15.253 0 0 15.253 0 34v524.253c0 18.748 15.252 34 34 34h665.884c18.748 0 34-15.252 34-34V34c0-18.747-15.252-34-34-34z",
    fill: "#7770b1",
    opacity: 0.6
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M414.728 289.755H85.498c-8.837 0-16-7.163-16-16V171.482c0-8.837 7.163-16 16-16h329.23c8.837 0 16 7.163 16 16v102.272c0 8.837-7.163 16.001-16 16.001z",
    fill: "url(#v)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M648.386 187.483H494.105c-8.837 0-16-7.163-16-16s7.163-16 16-16h154.281c8.837 0 16 7.163 16 16 0 8.836-7.163 16-16 16z",
    fill: "url(#w)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M648.386 229.399H494.105c-8.837 0-16-7.163-16-16s7.163-16 16-16h154.281c8.837 0 16 7.163 16 16 0 8.836-7.163 16-16 16z",
    fill: "url(#x)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M648.386 271.315H494.105c-8.837 0-16-7.163-16-16s7.163-16 16-16h154.281c8.837 0 16 7.163 16 16s-7.163 16-16 16z",
    fill: "url(#y)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M648.386 125.101H85.498c-8.837 0-16-7.163-16-16V73.233c0-8.837 7.163-16 16-16h562.888c8.837 0 16 7.163 16 16v35.868c0 8.836-7.163 16-16 16z",
    fill: "#8e84be"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M293.353 527.243H85.498c-8.837 0-16-7.163-16-16V355.978c0-8.837 7.163-16 16-16h207.855c8.837 0 16 7.163 16 16v155.264c0 8.837-7.164 16.001-16 16.001z",
    fill: "url(#z)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#7770b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.434 522.387h-37.717c-5.523 0-10-4.477-10-10v-206.26c0-5.523 4.477-10 10-10h37.717c5.523 0 10 4.477 10 10v206.26c0 5.523-4.477 10-10 10zm-76.235 0h-37.717c-5.523 0-10-4.477-10-10v-101.93c0-5.523 4.477-10 10-10h37.717c5.523 0 10 4.477 10 10v101.929c0 5.524-4.477 10.001-10 10.001zm-76.235 0h-37.717c-5.523 0-10-4.477-10-10V349.978c0-5.523 4.477-10 10-10h37.717c5.523 0 10 4.477 10 10v162.409c0 5.523-4.478 10-10 10zm-76.236 0h-37.717c-5.523 0-10-4.477-10-10v-67.444c0-5.523 4.477-10 10-10h37.717c5.523 0 10 4.477 10 10v67.444c0 5.523-4.477 10-10 10z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.71428571428572 391.07142857142856) rotate(0.0 340.17857142857144 200.89285714285717) scale(1.07302543605388 1.0737708235182728)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 634.055,
    height: 374.182,
    viewBox: "0 0 634.055 374.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 646.05,
    x2: -140.735,
    y1: 100.989,
    y2: 306.884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#bf78a9",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db9dc6"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 589.071,
    x2: 313.183,
    y1: 273.431,
    y2: 19.954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#bf78a9",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e499c2"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M607.456 366.144H26.6c-11.046 0-20-8.954-20-20V28.039c0-11.046 8.954-20 20-20h580.856c11.046 0 20 8.954 20 20v318.105c0 11.046-8.954 20-20 20z",
    fill: "url(#A)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M604.055 10c11.046 0 20 8.954 20 20v314.182c0 11.046-8.954 20-20 20H30c-11.046 0-20-8.954-20-20V30c0-11.046 8.954-20 20-20zm0-10H30C13.458 0 0 13.458 0 30v314.182c0 16.542 13.458 30 30 30h574.055c16.542 0 30-13.458 30-30V30c0-16.542-13.458-30-30-30z",
    fill: "#bf78a9",
    opacity: 0.6
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M376.271 122.418H65.155c-5.523 0-10-4.477-10-10V66.376c0-5.523 4.477-10 10-10h311.116c5.523 0 10 4.477 10 10v46.042c0 5.523-4.478 10-10 10z",
    fill: "#e499c2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M568.9 317.806H421.294c-5.523 0-10-4.477-10-10V66.376c0-5.523 4.477-10 10-10H568.9c5.523 0 10 4.477 10 10v241.43c0 5.523-4.477 10-10 10z",
    fill: "url(#B)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#e499c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.92 180.159H66.506c-6.269 0-11.351-5.082-11.351-11.351 0-6.269 5.082-11.351 11.351-11.351H374.92c6.269 0 11.351 5.082 11.351 11.351 0 6.27-5.082 11.351-11.351 11.351zm0 45.883H66.506c-6.269 0-11.351-5.082-11.351-11.351 0-6.269 5.082-11.351 11.351-11.351H374.92c6.269 0 11.351 5.082 11.351 11.351 0 6.269-5.082 11.351-11.351 11.351zm0 45.882H66.506c-6.269 0-11.351-5.082-11.351-11.351 0-6.269 5.082-11.351 11.351-11.351H374.92c6.269 0 11.351 5.082 11.351 11.351 0 6.269-5.082 11.351-11.351 11.351zm0 45.882H66.506c-6.269 0-11.351-5.082-11.351-11.351 0-6.269 5.082-11.351 11.351-11.351H374.92c6.269 0 11.351 5.082 11.351 11.351 0 6.269-5.082 11.351-11.351 11.351z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg);
export default __webpack_public_path__ + "static/media/banner-img.481510e5ec6a609844ab63092f809167.svg";
export { ForwardRef as ReactComponent };